import type { AudioCategory, PresentationState } from "../types";

export type CinematicAudioDuckSource = "boss-reveal" | "arena-effect";

/**
 * Background channels remain audible enough to preserve the room while the
 * projection's own soundtrack or impact stays dominant.
 */
export const CINEMATIC_AUDIO_DUCK_MULTIPLIERS: Readonly<Record<AudioCategory, number>> = {
  ambience: 0.24,
  music: 0.16,
  sfx: 0.42,
};

export function cinematicAudioDuckSource(presentation: Pick<PresentationState, "bossReveal" | "arenaEffect">): CinematicAudioDuckSource | undefined {
  if (presentation.bossReveal) return "boss-reveal";
  if (presentation.arenaEffect) return "arena-effect";
  return undefined;
}

export function cinematicAudioDuckMultiplier(category: AudioCategory, source: CinematicAudioDuckSource | undefined): number {
  return source ? CINEMATIC_AUDIO_DUCK_MULTIPLIERS[category] : 1;
}
